"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = exports.DialogFooter = exports.DialogBody = exports.DialogHeader = void 0;
const React = require("react");
const Button_1 = require("../../atoms/Button");
const dialogs_1 = require("../../../../types/dialogs");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Dialog");
const DialogHeader = ({ children = null, className }) => {
    if (!children) {
        return null;
    }
    return (React.createElement("div", { className: css("header", { className }), "data-test": "dialog-header" },
        React.createElement("h3", null, children)));
};
exports.DialogHeader = DialogHeader;
const DialogBody = ({ children, fixedHeight = false, className }) => (React.createElement("div", { className: css("body", { "-fixedHeight": fixedHeight, className }), "data-test": "dialog-body" }, children));
exports.DialogBody = DialogBody;
const DialogFooter = ({ onAccept, acceptLabel = "Done", acceptDisabled = false, onCancel, cancelLabel, actions, children }) => {
    // quick format for accept callback
    if (onAccept) {
        actions = [
            { onClick: onAccept, label: acceptLabel, disabled: acceptDisabled }
        ];
    }
    if (!(onCancel || actions || children)) {
        return null;
    }
    return (React.createElement("div", { className: css("footer"), "data-test": "dialog-footer" },
        onCancel && (React.createElement("span", { className: css("footer_cancel"), "data-test": "cancel" },
            React.createElement(Button_1.AltButton, { onClick: onCancel }, cancelLabel ? cancelLabel : "Cancel"))),
        children,
        actions &&
            actions.map((action, i) => [
                " ",
                React.createElement("span", { key: i, "data-test": "accept", className: css("footer_accept") },
                    React.createElement(Button_1.Button, { onClick: action.onClick, disableOnSuccess: false, disabled: action.disabled }, action.label))
            ])));
};
exports.DialogFooter = DialogFooter;
const Dialog = ({ size = dialogs_1.TDialogSizes.Medium, children, className, sticky = false, closeable = true }) => {
    return (React.createElement("div", { className: css("", `-size-${size}`, {
            "-sticky": sticky,
            "-closeable": closeable,
            className
        }), "data-test": "dialog-content" }, children));
};
exports.Dialog = Dialog;
exports.default = exports.Dialog; // TODO: remove me
//# sourceMappingURL=index.js.map